import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast ,ToastContainer} from "react-toastify";
import LightText, { BigerTexts } from "../../Assets/CSS/Text";
import Layout from "../../Components/Layout";

function CreateTask() {
  const navigate = useNavigate();
  const [taskDescription, setTaskDescription] = useState("");
  const [taskTitle, setTaskTitle] = useState("");
  const [assignedToEmployeeId, setAssignedToEmployeeId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/list`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setEmployeeList(response?.data);
        console.log("employee data ", response?.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployees();
  }, []);

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/projects`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response?.data, `project data`);
        setProjectList(response?.data?.content);
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, []);

  const handleSubmit = async () => {
    // ✅ Validation
    if (!taskTitle.trim()) {
      toast.error("Task title is required");
      return;
    }
    if (!startDate) {
      toast.error("Start date is required");
      return;
    }
    if (!endDate) {
      toast.error("Due date is required");
      return;
    }
    if (!selectedProjectId) {
      toast.error("Project selection is required");
      return;
    }
    if (!assignedToEmployeeId) {
      toast.error("Assignee is required");
      return;
    }
    if (!taskDescription.trim()) {
      toast.error("Description is required");
      return;
    }
    //  Optional: check date logic
    if (new Date(startDate) > new Date(endDate)) {
      toast.error("Start date cannot be after due date");
      return;
    }

    const payload = {
      taskTitle,
      taskDescription,
      assignedToEmployeeId,
      startDate,
      endDate,
    };

    console.log(selectedProjectId, "project id ");
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/${selectedProjectId}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Task created successfully!");
      navigate(`/mytask`);
    } catch (error) {
      console.error("Error creating task:", error);
      toast.error("Failed to create task.");
    }
  };

  return (
    <Layout>
       <ToastContainer
        position="top-right"
        autoClose={3000}
      
      />

      <div className="backgound-main-content" style={{ minHeight: "600px" }}>
        <div className="d-flex gap-2 align-item-center mt-2">
          <h5 style={BigerTexts}>Create New Task</h5>
        </div>

        <div className="row g-4 mt-2 ">
          {/* Task Description */}
          <div className="col-12 col-md-8">
            <label className="form-label" style={LightText}>
              Task<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Title"
              style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
              value={taskTitle}
              onChange={(e) => setTaskTitle(e.target.value)}
            />
          </div>
          <div className=" row mt-2">
            {/* Start Date */}
            <div className="col-12 col-md-4">
              <label className="form-label" style={LightText}>
                Start Date<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            {/* Due Date */}
            <div className="col-12 col-md-4">
              <label className="form-label" style={LightText}>
                Due Date<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <div className=" row mt-2">
            {/* project */}
            <div className="col-12 col-md-4">
              <label className="form-label" style={LightText}>
                Project<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                value={selectedProjectId}
                onChange={(e) => setSelectedProjectId(e.target.value)}
              >
                <option value="" disabled>
                  Select Project
                </option>
                {projectList.map((proj) => (
                  <option key={proj.projectId} value={proj.projectId}>
                    {proj.projectName}
                  </option>
                ))}
              </select>
            </div>

            {/* Assignee */}
            <div className="col-12 col-md-4">
              <label className="form-label" style={LightText}>
                Assignee<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                value={assignedToEmployeeId}
                onChange={(e) => setAssignedToEmployeeId(e.target.value)}
              >
                <option value="" disabled>
                  Select assignee
                </option>
                {employeeList.map((emp) => (
                  <option key={emp.id} value={emp.empId}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-8">
            <label className="form-label" style={LightText}>
              Description<span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              placeholder="Enter description"
              style={{
                borderColor: "#C8C8C8",
                borderRadius: "10px",
                minHeight: "100px",
              }}
              value={taskDescription}
              onChange={(e) => setTaskDescription(e.target.value)}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-3 mt-4">
          <button
            className="btn border-secondary px-4"
            style={{ color: "#909090" }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{
              backgroundColor: "#00AFEF",
              borderRadius: "10px",
              color: "#fff",
            }}
            onClick={handleSubmit}
          >
            + Create Task
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default CreateTask;
